/**
 * @generated SignedSource<<170443fb4b7d9d47f007023d44c6db43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  "contributions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contributionsCount"
    },
    {
      "kind": "RootArgument",
      "name": "contributionsCursor"
    },
    {
      "kind": "RootArgument",
      "name": "contributionsFilters"
    },
    {
      "kind": "RootArgument",
      "name": "contributionsSort"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "contributionsCount",
        "cursor": "contributionsCursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "contributionsCount",
          "cursor": "contributionsCursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ContributionsDatavizGraphThemePaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ContributionsDatavizGraphTheme_theme",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModule",
      "kind": "LinkedField",
      "name": "participativeModule",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsDatavizMainContainerHeader_participativeModule"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContributionsDatavizViewModeSwitch_participativeModule"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "contributions",
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "contributionsFilters"
        },
        {
          "kind": "Variable",
          "name": "sort",
          "variableName": "contributionsSort"
        }
      ],
      "concreteType": "ContributionConnection",
      "kind": "LinkedField",
      "name": "__ContributionsDatavizGraphTheme_contributions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContributionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Contribution",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isBookmarked",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isMine",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "reactionsCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Theme",
                  "kind": "LinkedField",
                  "name": "themes",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizThemeLayout_theme"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizGraphThemeAnimation_theme"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizMainContainerHeader_theme"
    },
    (v1/*: any*/)
  ],
  "type": "Theme",
  "abstractKey": null
};
})();

node.hash = "2c12e6b744331728e05f0c9bcdcd772c";

module.exports = node;
